import { render, staticRenderFns } from "./NotificationType.vue?vue&type=template&id=4feb5c52&"
import script from "./NotificationType.vue?vue&type=script&lang=js&"
export * from "./NotificationType.vue?vue&type=script&lang=js&"
import style0 from "./NotificationType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports